import { render } from "./VisibilityOffIcon.vue?vue&type=template&id=5bbde0b3"
import script from "./VisibilityOffIcon.vue?vue&type=script&lang=js"
export * from "./VisibilityOffIcon.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__